import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgDataTableComponent, ExgModalService, ExgPopupComponent} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';

@Component({
  selector: 'app-receipt-company-list',
  templateUrl: './receipt-company-list.component.html',
  styles: [
  ]
})
export class ReceiptCompanyListComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  @ViewChild('VCCompanyTable', {read: ExgDataTableComponent}) VCCompanyTable!: ExgDataTableComponent;
  @ViewChild('VCCompanyTableFilterPopup', {read: ExgPopupComponent}) VCCompanyTableFilterPopup!: ExgPopupComponent;
  @ViewChild('VCCompanyTableSortPopup', {read: ExgPopupComponent}) VCCompanyTableSortPopup!: ExgPopupComponent;
  @ViewChild('VCCompanyTableSearchPopup', {read: ExgPopupComponent}) VCCompanyTableSearchPopup!: ExgPopupComponent;
  @ViewChild('VCCompanyTableFilterControl', {read: ExgFilterComponent}) VCCompanyTableFilterControl!: ExgFilterComponent;

  companyTable = {
    selectKey: 'compID',
    state: 1,
    selectedRow: undefined as any,
    prefilter_DEL: 0,
    searchValue: '',
    uiFilter: [],
    uiSort: [],
    data: [] as any [],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: false,
    selectionChanged: (index: number) => {
      this.companyTable.selectedRow = this.companyTable.data[index];
    },
    pageChanged: (page: number) => {
      if (this.companyTable.MetaInfo.dataPaging !== undefined) {
        this.companyTable.MetaInfo.dataPaging.pageNo = page;
        this.loadCompanyList();
      }
    },
    search: (value: string) => {
      this.companyTable.searchValue = value;
      this.companyTable.pageChanged(0);
    },
    ready: () => {
      this.companyTable.isLoading = false;
      if (this.companyTable.data.length === 0) {
        this.companyTable.state = 2;
        this.VCCompanyTable.selectedRow = -1;
      } else {
        this.companyTable.state = 0;
        this.VCCompanyTable.selectedRow = 0;
      }
    },
    loadData: (incomingData: any, incomingPaging: any) => {
      this.companyTable.data = incomingData.filter((comp: any) => comp.compDEL === false);
      this.companyTable.paging = incomingPaging;
      this.companyTable.ready();
    },
    isFiltered: () => {
      return !(this.companyTable.MetaInfo.dataFilter);
    }
  };
  rightDrawerVisible = false;

  togglePopupMenu(e: any, context: any, pos: string = 'underleft'): void {
    if (context) {
      if (context.visibility === 'hidden') {
        switch (pos) {
          case 'underleft': {
            context.openUnderLeft(e);
            break;
          }
          case 'abovecenter': {
            context.openAboveCenter(e);
            break;
          }
        }
      } else {
        context.close();
      }
    }
  }

  closePopupMenuAndReload(): void {
    this.VCCompanyTableFilterPopup.close();
    this.VCCompanyTableSortPopup.close();
    this.VCCompanyTableSearchPopup.close();
    this.loadCompanyList();
  }

  constructor(
    private popUpService: ExgModalService,
    public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.loadCompanyList();
  }

  close(): void {
    this.popUpService.action({});
  }

  send(): void {
    if (this.companyTable.selectedRow) {
      if (!this.data.rcptLink) {
        this.popUpService.action({
          compToRcpt: true
          , compID: this.companyTable.selectedRow.compID
          , compUPT: this.companyTable.selectedRow.compUPT});
      } else {
        this.popUpService.action({
          compLinkRcpt: true
          , compID: this.companyTable.selectedRow.compID
          , compUPT: this.companyTable.selectedRow.compUPT});
      }
    }
  }

  loadCompanyList(): void {
    this.data.checkviewFunction(this.companyTable);
  }

  delete(): void {
    this.popUpService.action({compDoDel: true
      , compID: this.companyTable.selectedRow.compID
      , compUPT: this.companyTable.selectedRow.compUPT});
    // doDelete
  }

  isNumberString(value: unknown): boolean {
    if (!value) {
      return false;
    }
    const s = String(value).trim();

    // erlaubt:  "12", "-12", "12.3", "12,3"
    // nicht erlaubt: "", "12a", "1 2"
    return s !== '' && !Number.isNaN(Number(s.replace(',', '.')));
  }
}
